<template>
  <div class="wrapGridArea">
    <div class="title">엑셀 불러오기 / 내보내기 <span style="font-size:12px; color: #aaa; font-style: italic;">'내보내기'를 먼저하고, 엑셀의 데이터를 수정한 뒤 불러오기를 하여 결과를 확인할 수 있습니다.</span></div>
    <input type="file" onchange="importExcelData(event)" style="margin-bottom: 20px;">
    <button onclick="window.vl.$refs.view.$refs.grid.gridObject.exportData('xlsx', 'exportExcel')">내보내기</button>
    <SBGrid
      id="grid"
      style="width: 100%; height: 400px"
      ref="grid"
      :data="gridJson"
      :columns="grid1columns"
      :gridattr="{rowheader: 'seq', rowheadercaption : {seq: '순번'}, rowheaderwidth: {seq: '80'},extendcol: 14,showtotalrows:true}"
    ></SBGrid>
  </div>
</template>

<script>
import SBGrid from '../SBGrid.vue'
export default {
  data: function() {
    return {
      gridJson : [
        {"academy": "청량도우리이발기술학원","addr": "서울특별시 동대문구 왕산로33길 32 , 2층  (제기동)","name": "서현우","phone": "02-969-5025","curriculum": "beauty","class": "이발기술","maxstudent": "20","term": "1개월 0일","startday": "20170331","totalminute": "3780","pay": "300000","teacher": "1"},
        {"academy": "대성회계실무학원","addr": "서울특별시 동대문구 왕산로 225 , 5층2호, 5층6호 (청량리동)","name": "나강해","phone": "02-966-8400","curriculum": "synthesize","class": "전산회계1급","maxstudent": "17","term": "1개월 0일","startday": "20170331","totalminute": "4140","pay": "440920","teacher": "5"},
        {"academy": "대성회계실무학원","addr": "서울특별시 동대문구 왕산로 225 , 5층2호, 5층6호 (청량리동)","name": "임준수","phone": "02-966-8400","curriculum": "synthesize","class": "ITQ실무(한글, 엑셀, 파워포인트)","maxstudent": "13","term": "1개월 0일","startday": "20170331","totalminute": "6000","pay": "557900","teacher": "5"},
        {"academy": "국제전자과학학원","addr": "서울특별시동대문구  고산자로36길3  3층일부(제기동)","name": "강동오","phone": "02-967-0081","curriculum": "electron","class": "기사","maxstudent": "10","term": "1개월 0일","startday": "20170331","totalminute": "2260","pay": "180000","teacher": "1"},
        {"academy": "영란피아노음악학원","addr": "서울특별시 동대문구 이문로 70  (이문동)","name": "김효성","phone": "02-962-2460","curriculum": "music","class": "피아노","maxstudent": "45","term": "1개월 0일","startday": "20170331","totalminute": "1260","pay": "90000","teacher": "2"},
      ],
      grid1columns : [
        {caption : ['학원명'],		ref : 'academy',		width : '150px',	style : 'text-align:left',	type : 'output'},
        {caption : ['설립자(성명)'],	ref : 'name',			width : '100px',	style : 'text-align:center',	type : 'input'},
        {caption : ['전화번호'],		ref : 'phone',			width : '120px',	style : 'text-align:center',	type : 'input'},
        {caption : ['학원주소'],		ref : 'addr',			width : '450px',	style : 'text-align:left',	type : 'textarea'},
        {caption : ['교습과목(반)'],	ref : 'class',			width : '200px',	style : 'text-align:center',	type : 'input'},
        {caption : ['정원'],		 	ref : 'maxstudent',		width : '70px',	style : 'text-align:center',	type : 'input', format : {type:'string', rule:'@ "명"'}},
        {caption : ['교습기간'],		ref : 'term',			width : '100px',	style : 'text-align:center',	type : 'input'},
        {caption : ['교육시작일'],		ref : 'startday',		width : '100px',	style : 'text-align:center',	type : 'datepicker', typeinfo : {locale : 'ko' , dateformat :'yymmdd'}, format : {type:'date', rule:'yyyy-mm-dd', origin : 'yyyymmdd' }},
        {caption : ['총교습시간(분)'],   ref : 'totalminute',		width : '100px',	style : 'text-align:center',	type : 'input'},
        {caption : ['교습비'],		ref : 'pay',			width : '100px',	style : 'text-align:center',	type : 'input', format : {type:'number', rule:'#,###'}},
        {caption : ['강사수'],		ref : 'teacher',			width : '70px',	style : 'text-align:center',	type : 'input'}
      ]
    }
  },
  components: {
    SBGrid
  }
}
window.importExcelData = function(e) {
  window.vl.$refs.view.$refs.grid.gridObject.importExcelData(e)
};
</script>

<style>

</style>